// extracted by mini-css-extract-plugin
module.exports = {"overflow":"magicIndex_overflow__3OsOC","wrapper":"magicIndex_wrapper__1pNaX"};